/**
 * Builds a path that respects the app public URL (root in prod/dev, /autoreinscripcion in QA).
 */
export function withPublicUrl(path = '/') {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    if (!path || path === '/') {
        return base || '/';
    }

    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${base}${normalized}`;
}

export function getBasePath() {
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return publicUrl || '/';
}
